function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { FacebookUrl, InstagramUrl, LinkedinUrl, TwitterUrl, YoutubeUrl } from "./consts";
import { SocialMedia as SocialMediaEnum } from "./enums";
import FacebookIcon from "./icon-facebook.svg";
import InstagramIcon from "./icon-instagram.svg";
import LinkedinIcon from "./icon-linkedin.svg";
import TwitterIcon from "./icon-twitter.svg";
import YoutubeIcon from "./icon-youtube.svg";
import { Container, IconContainer } from "./styles";
export const SocialMedia = ({
  ...props
}) => {
  const {
    handleTrackGA4
  } = useSdkContext();
  const socialMediaMap = {
    [SocialMediaEnum.Facebook]: {
      icon: FacebookIcon,
      url: FacebookUrl
    },
    [SocialMediaEnum.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl
    },
    [SocialMediaEnum.Linkedin]: {
      icon: LinkedinIcon,
      url: LinkedinUrl
    },
    [SocialMediaEnum.Twitter]: {
      icon: TwitterIcon,
      url: TwitterUrl
    },
    [SocialMediaEnum.Youtube]: {
      icon: YoutubeIcon,
      url: YoutubeUrl
    }
  };
  const renderIcon = media => {
    const {
      icon: Component,
      url
    } = socialMediaMap[media];
    return /*#__PURE__*/React.createElement(IconContainer, {
      key: media,
      "data-qa": "render-icon"
    }, /*#__PURE__*/React.createElement("a", {
      href: url,
      rel: "noopener noreferrer",
      target: "_blank",
      title: "Follow SCMP",
      onClick: () => {
        handleTrackGA4({
          action: "click",
          category: "footer",
          customized_parameters: {
            destination_url: url,
            link_name: media,
            social_platform: media
          },
          subcategory: ""
        });
      }
    }, /*#__PURE__*/React.createElement(Component, null)));
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "social-media"
  }), [SocialMediaEnum.Facebook, SocialMediaEnum.Twitter, SocialMediaEnum.Youtube, SocialMediaEnum.Instagram, SocialMediaEnum.Linkedin].map(media => renderIcon(media)));
};
SocialMedia.displayName = "SocialMedia";